export const roadA2 = [
    
    {
        id: 0,
        thumbnail: "https://i.ibb.co/rpNz4py/B2-FIRST-31.png",
        title: " Antes del Curso",
        subtitle: "Centro de Clasificación ",
    
        dateAdded: "Basic 0 ",
        channel: " ",
        description: "Si has llevado clases de inglés antes realiza un examen para calcular tu nivel,Envia tu examen para su corrección al correo temis_it@hotmail.com",
        enlaces: [
            {  titulo:"Presentación del Curso",url: "https://www.youtube.com/watch?v=_1DEJIOcJmY&t=2s"},        

        ],
    },
   
    {
        id: 1,
        thumbnail: "https://i.ibb.co/rpNz4py/B2-FIRST-31.png",

        title: "Rutinas y Tiempo Libre",
        subtitle: "Nivel Básico ",
    
        dateAdded: "Basic 0 ",
        channel: "Aprenderemos a presentarnos, deletrear nombres y palabras, describir personas, presentar a la familia y brindar información personal.",
        description: "Aprenderemos Vocabulario básico para poder expresarnos poco a poco en Inglés",
        enlaces: [

         
            {  titulo:"Present Simple Afirmativo", url:"https://drive.google.com/file/d/1RPry6CTichsaflus2gbVIV3mE4l6mdl4/view?usp=sharing",url4: "https://youtu.be/S3TbSR-TJ3A",url5:"https://wordwall.net/play/57830/431/8032"},
            {  titulo:"Las Frutas y Comidas", url:"https://drive.google.com/file/d/1_gQgAhEJ38c7XLp3qmNqNECjRqORdt73/view?usp=sharing",url4: "https://youtu.be/-T9Au-rGWbY"},
            {  titulo:"Lugares",url: "https://drive.google.com/file/d/11sYrVn0MrbnyEA79IvmqGhBfsgE1EnLk/view?usp=sharing",url4:"https://youtu.be/F8loOzvWhTA" },

            {  titulo:"Object Pronouns ",url: "https://drive.google.com/file/d/1MgV9Cd2rVyOoJ3Bd3_P692S8q-Yaxu9h/view?usp=sharing" ,url4:"https://youtu.be/vW-vTszH4xw",url5: "https://wordwall.net/play/69980/389/917" },
            {  titulo:"Household Objects",url: "https://drive.google.com/file/d/1P-c8iqNpEPg0xqZSy8A_Ydtf9mWVb-2q/view?usp=sharing",url4:"https://youtu.be/BA8hzf7rp-w" },

            {  titulo:"Present Simple Negative & Interrogative ",url:"https://drive.google.com/file/d/1WfymWBrEMkm8gLLvgqGoSvXy83WvlrC_/view?usp=sharing" ,url4: "https://youtu.be/QANvYn5QEUs"},
            { titulo: "Adverbs of Frequency",url: "https://docs.google.com/presentation/d/12feKDZwOqILPrUSp6Nm6vtYqfcgjaQqR/edit?usp=sharing&ouid=114172849724389982127&rtpof=true&sd=true",url4:"https://youtu.be/pkQdCn7qlHc",  url5: "https://wordwall.net/play/54781/327/2832"},
             
            
       
        ],
    },
     {
        id: 2,
        thumbnail: "https://i.ibb.co/mX3PsJ2/B2-FIRST-28.png",
        title: " Be affirmative",
        subtitle: "Centro de Clasificación ",
    
        dateAdded: "Basic 0 ",
        channel: " ",
        description: "Si has llevado clases de inglés antes realiza un examen para calcular tu nivel,Envia tu examen para su corrección al correo temis_it@hotmail.com",
        enlaces: [

            {  titulo:"[🖥️ Class] Prensent Simple with Be Afirmativo", url: "https://youtu.be/Qn3u8ixM4B8"},
            {  titulo:"[📊 Diagrama] Prensent Simple with Be Afirmativo", url: "https://drive.google.com/file/d/1y0DhY1JVNKt36a7-0ozVwmmUgkVMd_46/view?usp=sharing"},
            {  titulo:"[🧩 Activity] The Verb Be Affirmative Form I", url: "https://wordwall.net/play/13293/724/51767" },
            {  titulo:"[🧩 Activity] The Verb Be Affirmative Form II", url: "https://wordwall.net/play/14390/465/80013" },
            {  titulo:"[🧩 Activity] The Verb Be Affirmative Form III", url: "https://wordwall.net/play/11554/389/1088" },
          
            {  titulo:"[🖥️ Solution] Practicando el Verbo Be Affirmative Form", url: "https://youtu.be/Z9Y7IWFNX_Q"},
            {  titulo:"[🔖Practice]The Verb Be Affirmative Form",url: "https://drive.google.com/file/d/1fieorI4c7zCUt6ltKNrXlVX8aPXogvcb/view?usp=sharing" },
            {  titulo:"Las Frutas", url: "https://drive.google.com/file/d/1w2CwNRwhzm2zI7Wui33WHAiRWjPY74xl/view?usp=sharing"},
            {  titulo:"Los Números", url: "https://drive.google.com/file/d/1v8Llb28x3bJCDzuRgfDJXPOmqbRkMKuz/view?usp=sharing"},
            {  titulo:" Objetos de la casa ",url: "https://drive.google.com/file/d/1oJafOHW9rzR4-85EycQtGtZaDaHuIHdg/view?usp=sharing" },
            {  titulo:" Partes del Cuerpo",url: "https://drive.google.com/file/d/16M8ghnjnDxLr-IhhuCfhHPOK7aXUz6ac/view?usp=sharing" },
            {  titulo:" Lugares en Inglés",url: "https://drive.google.com/file/d/1zMMYEvI0nWXQZWpawErZ5J7OgnPf4rgO/view?usp=sharing" },
            {  titulo:" Los colores",url: "https://drive.google.com/file/d/18iiQLhwnGzGnfJQxnZrsBlt8YLyA38wz/view?usp=sharing" },
            {  titulo:" Los Animales",url: "https://drive.google.com/file/d/1hhtj5vmynyNva8Rx92O1yvR_7Wa0rPKb/view?usp=sharing" },

          
          
        ],
    },
 
     {
        id: 3,
        thumbnail: "https://i.ibb.co/mX3PsJ2/B2-FIRST-28.png",
        title: "Be Negative",
        subtitle: "Centro de Clasificación ",
    
        dateAdded: "Basic 0 ",
        channel: " ",
        description: "Si has llevado clases de inglés antes realiza un examen para calcular tu nivel,Envia tu examen para su corrección al correo temis_it@hotmail.com",
        enlaces: [

            {  titulo:"[🖥️ Class] Prensent Simple with Be Negative", url: "https://drive.google.com/file/d/1CVydEJyBwS2X_9A_A4kRBleq_glgCopc/view?usp=sharing",url2: "https://youtu.be/bBUUAjkC0Go"},

            {  titulo:"[🔖Practice]The Verb Be Negative Form",url: "https://drive.google.com/file/d/15uWVRNGSUj0D8zZQ-O6K-UjTiArG5TA3/view?usp=sharing" },
            {  titulo:"[🧩 Activity] The Verb Be Negative Form", url: "https://wordwall.net/play/21158/025/3896" },
            {  titulo:"[📝 FunSheet] BE VERB: Negative",url: "https://drive.google.com/file/d/1Y5UlRlzuV3TLR79_IutdZYshmYs23cIf/view?usp=sharing"},
          {  titulo:"[🖥️ Class] Prensent Simple with Be Negative", url: "https://youtu.be/bBUUAjkC0Go"},
            {  titulo:"[📊 Diagrama] Prensent Simple with Be Negative", url: "https://drive.google.com/file/d/1CVydEJyBwS2X_9A_A4kRBleq_glgCopc/view?usp=sharing"},
          {  titulo:"[🧩 Activity] The Verb Be Negative Form", url: "https://wordwall.net/play/21158/025/3896" },
            {  titulo:"[📝 FunSheet] BE VERB: Negative",url: "https://drive.google.com/file/d/1Y5UlRlzuV3TLR79_IutdZYshmYs23cIf/view?usp=sharing"},
            {  titulo:"[🔖Practice]The Verb Be Negative Form",url: "https://drive.google.com/file/d/15uWVRNGSUj0D8zZQ-O6K-UjTiArG5TA3/view?usp=sharing" },

        ],
    },
    {
        id: 4,
        thumbnail: "https://i.ibb.co/mX3PsJ2/B2-FIRST-28.png",
        title: "Be Interrogative",
        subtitle: "Centro de Clasificación ",
    
        dateAdded: "Basic 0 ",
        channel: " ",
        description: "Si has llevado clases de inglés antes realiza un examen para calcular tu nivel,Envia tu examen para su corrección al correo temis_it@hotmail.com",
        enlaces: [
 
            {  titulo:"[🖥️ Class] Prensent Simple with Be Interrogativa", url: "https://youtu.be/oWnUpDh-z9Y"},
            {  titulo:"[📊 Diagrama] Prensent Simple with Be Interrogative", url: "https://drive.google.com/file/d/1CVydEJyBwS2X_9A_A4kRBleq_glgCopc/view?usp=sharing"},
            {  titulo:"[🧩 Activity] The Verb Be Interrogative Form I", url: "https://wordwall.net/play/1856/077/57902" },
            {  titulo:"[🧩 Activity] The Verb Be Interrogative Form II", url: "https://wordwall.net/play/58086/380/593" },
                {  titulo:"[🔖Practice]The Verb Be Yes/No Questions",url: "https://drive.google.com/file/d/1s7zZgtpqjsuc3i81bFhfj7PhUWrNoUX7/view?usp=sharing" },
            {  titulo:"[🔖Practice]The Verb Be Wh Questions ",url: "https://drive.google.com/file/d/1MFejzFjYgHoSPlsoNQLF07R4-y107XcC/view?usp=sharing" },
            {  titulo:"[🔖Practice]The Verb Be Mixed I ",url: "https://drive.google.com/file/d/1NVzc8Cl78PSxJfxwJJQCb4JH8EKcpVKT/view?usp=sharing" },
            {  titulo:"[🔖Practice]The Verb Be Mixed II ",url: "https://drive.google.com/file/d/1qqvXwkB_yUCHU4nAOaItjenf8AwaBy6p/view?usp=sharing" },
        
          
        
        
        ],
    },
    
    {
        id: 5,
        thumbnail: "https://i.ibb.co/mX3PsJ2/B2-FIRST-28.png",

           
            title: "Fundamentos II ",
        subtitle: "Basic Level",
    imagenseccion: "https://i.ibb.co/B6gr9Gd/Black-White-and-Red-Simple-Shield-Shape-Football-Club-Logo-2-removebg-preview.png",
      categoria:"speaking",
        dateAdded: "Basic 0 ",
        channel: "",
        description: "Curso básico de inglés para los que están empezando.",
        enlaces: [
               {  titulo:"Las Nacionalidades", url: "https://drive.google.com/file/d/1t-NO8pU0eJr-CqjYoeakkTnZOWB7odPw/view?usp=sharing"},
            {  titulo:"Los Adjetivos", url: "https://drive.google.com/file/d/1a4bQQNWNjxPwO82z4ztO51A0Nq2GhVVv/view?usp=sharing"},
            {  titulo:" Las estaciones ",url: "https://drive.google.com/file/d/1LGxrtVKrUYzgQfyNiaFGa2OhQG5WK2QL/view?usp=sharing" },
            {  titulo:" Las Profesiones ",url: "https://drive.google.com/file/d/1k9ve-mH0Ja3oN3P-S2fuEy93gnHgs49k/view?usp=sharing" },
            {  titulo:" Miembros de la familia",url: "https://drive.google.com/file/d/1cFE24uSHz39qd2F7QWD-A_Vr7I0GoD9P/view?usp=sharing" },

            {  titulo:"[🖥️ Class] Demonstrative Pronouns", url: "https://youtu.be/K2v046W9AoE"},

            {  titulo:"[🗂️Slide] Demonstrative Pronouns ",url: "https://docs.google.com/presentation/d/18Y9eWTC4cdzK1L3EEFhNz7OFCtKjWIFh/edit?usp=sharing&ouid=101677822942011312590&rtpof=true&sd=true",},
           {  titulo:"[🖥️ Class] Demonstrative Adjectives", url: "https://youtu.be/K2v046W9AoE"},
            {  titulo:"[🗂️Slide] Demonstrative Adjectives ",url: "https://docs.google.com/presentation/d/1hw4LZ3Tma1QFhHUwTdENPHhRcvaE9Rdv/edit?usp=sharing&ouid=101677822942011312590&rtpof=true&sd=true",},
            {  titulo:"[🖥️ Class] Demonstrative Pronouns", url: "https://youtu.be/K2v046W9AoE"},
            {  titulo:"[🗂️Slide] Demonstrative Pronouns ",url: "https://docs.google.com/presentation/d/18Y9eWTC4cdzK1L3EEFhNz7OFCtKjWIFh/edit?usp=sharing&ouid=101677822942011312590&rtpof=true&sd=true",},
            {  titulo:"[📑 GrammarSheet] Contractions with Be",url: "https://drive.google.com/file/d/1RbxiaSl1dFwOq7sFTF_7TRRmIpapN1XN/view?usp=sharing"},

            {  titulo:"[📝 FunSheet] GRAMMAR ERROR CORRECTION BE",url: "https://drive.google.com/file/d/15RV8Qi_oXfnAjFGbZ2XE_MeZra8XPvot/view?usp=sharing"},

             {  titulo:"[📑 GrammarSheet] Contractions with Be",url: "https://drive.google.com/file/d/1RbxiaSl1dFwOq7sFTF_7TRRmIpapN1XN/view?usp=sharing"},

            {  titulo:"[📝 FunSheet] GRAMMAR ERROR CORRECTION BE",url: "https://drive.google.com/file/d/15RV8Qi_oXfnAjFGbZ2XE_MeZra8XPvot/view?usp=sharing"},
            {  titulo:"[🔖Practice]The Verb Be Affirmative Form",url: "https://drive.google.com/file/d/1fieorI4c7zCUt6ltKNrXlVX8aPXogvcb/view?usp=sharing" },
           
            {  titulo:"[🖥️ Class] Prensent Simple with Be Interrogativa", url: "https://youtu.be/oWnUpDh-z9Y"},
            {  titulo:"[📊 Diagrama] Prensent Simple with Be Interrogative", url: "https://drive.google.com/file/d/1CVydEJyBwS2X_9A_A4kRBleq_glgCopc/view?usp=sharing"},

         
            {  titulo:"[🖥️ Solution] Practicando el Verbo Be Negative & Interrogative Form", url: "https://youtu.be/L0yrUtFO1pE"},
            {  titulo:"📖 Grammar Discussion  Verb be", url: "https://drive.google.com/file/d/1TT9jj4dJ_ylAh64LjBYe8Gjq4GzOOjxg/view?usp=sharing"},
            {  titulo:"📖 Grammar Discussion  Verb be", url: "https://drive.google.com/file/d/1TT9jj4dJ_ylAh64LjBYe8Gjq4GzOOjxg/view?usp=sharing"},

            {  titulo:"📖 The Verb Be Negative and Interrogative Form", url: "https://docs.google.com/presentation/d/1-37e0Rj12xLoLJ8AIadt47Q0q-D8JbkR/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true"},
            {  titulo:"📃The Verb Be Affirmative Form",url: "https://drive.google.com/file/d/1rTn31H9zJcXSRVNm1MGJ-se_3PFChW_N/view?usp=sharing" },

            {  titulo:"📖  Be-WH Questions", url: "https://docs.google.com/presentation/d/1QzcM-95Md4pWWy1d6BzM2CX2klPaPbXT/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true"},
            {  titulo:"📖Correct the Sentences with The Verb Be in Questions",url: "https://docs.google.com/presentation/d/1PmPGCCydt73O4vXTB9ThQdiMk-zSdZs0/edit?usp=sharing&ouid=114172849724389982127&rtpof=true&sd=true",},
            { titulo: "💡🎦 Present Tense Simple Be 01  ",url: "https://drive.google.com/file/d/1O2eE2VUMwZLRuFiDaTvjE-zTIj15DP-h/view?usp=sharing", },

            {  titulo:"📖 Review Verb be ",url: "https://docs.google.com/presentation/d/1Ckb4LISBB35qHq5Yxf1sPEruLXAo-o6w/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true" },
            {  titulo:"[😎Slide] Speak Like a Native 01", url: "https://docs.google.com/presentation/d/17nnI3AdqbUoFzVws8KmozupnKy7K1VgU/edit?usp=sharing&ouid=101677822942011312590&rtpof=true&sd=true"},
            
          

           
            {
                titulo: "📒[slides] Making Suggestions Lets and Could",
                url: "https://docs.google.com/presentation/d/152lX6FIORqoOI59MOv28XNZ4CoxZNMEh/edit?usp=sharing&ouid=114172849724389982127&rtpof=true&sd=true",
            },
            {
                titulo: "📒[slides] Prepositions of Time",
                url: "https://docs.google.com/presentation/d/1aWoKAeyUeC6kUluXaBHWZhKoC2li7KLN/edit?usp=sharing&ouid=114172849724389982127&rtpof=true&sd=true",
            },
           
          
           
          
            {  titulo:"✍️Practica Integradora 1", url: "https://docs.google.com/document/d/1dEid7CxmlAwFluGbugI-3zH__ktx_KrV/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true", },



            
        ],
    },
    
   
   
    {
        id: 1,
        thumbnail: "https://i.ibb.co/rpNz4py/B2-FIRST-31.png",

        title: "Fundamentos III",
        subtitle: "Nivel Básico ",
    
        dateAdded: "Basic 0 ",
        channel: "Aprenderemos a presentarnos, deletrear nombres y palabras, describir personas, presentar a la familia y brindar información personal.",
        description: "Aprenderemos Vocabulario básico para poder expresarnos poco a poco en Inglés",
        enlaces: [
           
            {  titulo:"🗂️Slide] The Numbers and The Time", url: "https://docs.google.com/presentation/d/1lLVrkj4nl8wvv3aGmqasKH3Mioo09DE7/edit?usp=sharing&ouid=101677822942011312590&rtpof=true&sd=true"},
           
            {  titulo:"[🧩 Activity]have got/has got", url: "https://wordwall.net/play/4935/754/2603"},

            {  titulo:"[🧩 Activity] The Time  I", url: "https://wordwall.net/play/11993/400/13264"},
            {
                titulo: "📒[slides] La hora en Ingles",
                url: "https://docs.google.com/presentation/d/1En8CAC9wcrXYWSawMEirZO7gU8tsAmBi/edit?usp=sharing&ouid=114172849724389982127&rtpof=true&sd=true",
            },
          
           
            {  titulo:"📖 Ordinal Numbers ",url: "https://drive.google.com/file/d/18I58jFyIcYY_apm1YTzXvv2TVuMVHnXk/view?usp=sharing" },


          
       
         
            {  titulo:"📖Possessive", url: "https://docs.google.com/presentation/d/1UijMuEx-DdbZETXjEUUtT6IPkWF0az2w/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true"},
            {  titulo:"🧩Possessive Pronouns", url: "https://wordwall.net/play/52592/500/1753"},
            {  titulo:"[🖥️ Class] Adjectives", url: "https://youtu.be/CpG5KE79gFg"},
            {  titulo:"[🗂️Slide] Adjectives",url: "https://docs.google.com/presentation/d/1kfRo9rtah5D8Afgsj8zbV5iC1c1pOPju/edit?usp=sharing&ouid=101677822942011312590&rtpof=true&sd=true"},


            {  titulo:"[🧩 Activity] The Verb Be Interrogative Form I", url: "https://wordwall.net/play/1856/077/57902" },
            {  titulo:"[🧩 Activity] The Verb Be Interrogative Form II", url: "https://wordwall.net/play/58086/380/593" },
            {  titulo:"[🖥️ Solution] Practicando el Verbo Be Negative & Interrogative Form", url: "https://youtu.be/L0yrUtFO1pE"},
            {  titulo:"📖 Grammar Discussion  Verb be", url: "https://drive.google.com/file/d/1TT9jj4dJ_ylAh64LjBYe8Gjq4GzOOjxg/view?usp=sharing"},
            {  titulo:"📖 Grammar Discussion  Verb be", url: "https://drive.google.com/file/d/1TT9jj4dJ_ylAh64LjBYe8Gjq4GzOOjxg/view?usp=sharing"},

            {  titulo:"📖 The Verb Be Negative and Interrogative Form", url: "https://docs.google.com/presentation/d/1-37e0Rj12xLoLJ8AIadt47Q0q-D8JbkR/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true"},
            {  titulo:"📃The Verb Be Affirmative Form",url: "https://drive.google.com/file/d/1rTn31H9zJcXSRVNm1MGJ-se_3PFChW_N/view?usp=sharing" },

            {  titulo:"📖  Be-WH Questions", url: "https://docs.google.com/presentation/d/1QzcM-95Md4pWWy1d6BzM2CX2klPaPbXT/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true"},
            {  titulo:"📖Correct the Sentences with The Verb Be in Questions",url: "https://docs.google.com/presentation/d/1PmPGCCydt73O4vXTB9ThQdiMk-zSdZs0/edit?usp=sharing&ouid=114172849724389982127&rtpof=true&sd=true",},
            { titulo: "💡🎦 Present Tense Simple Be 01  ",url: "https://drive.google.com/file/d/1O2eE2VUMwZLRuFiDaTvjE-zTIj15DP-h/view?usp=sharing", },

            {  titulo:"📖 Review Verb be ",url: "https://docs.google.com/presentation/d/1Ckb4LISBB35qHq5Yxf1sPEruLXAo-o6w/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true" },
            {  titulo:"[😎Slide] Speak Like a Native 01", url: "https://docs.google.com/presentation/d/17nnI3AdqbUoFzVws8KmozupnKy7K1VgU/edit?usp=sharing&ouid=101677822942011312590&rtpof=true&sd=true"},
          
            {
                titulo: "📒[slides] Making Suggestions Lets and Could",
                url: "https://docs.google.com/presentation/d/152lX6FIORqoOI59MOv28XNZ4CoxZNMEh/edit?usp=sharing&ouid=114172849724389982127&rtpof=true&sd=true",
            },
            {
                titulo: "📒[slides] Prepositions of Time",
                url: "https://docs.google.com/presentation/d/1aWoKAeyUeC6kUluXaBHWZhKoC2li7KLN/edit?usp=sharing&ouid=114172849724389982127&rtpof=true&sd=true",
            },
           
          
           
          
            {  titulo:"✍️Practica Integradora 1", url: "https://docs.google.com/document/d/1dEid7CxmlAwFluGbugI-3zH__ktx_KrV/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true", },


        ],
    },
    
   
             
    
  
   

    {
        id: 6,
        thumbnail: "https://i.ibb.co/9wVtSxZ/B2-FIRST-18.png",
        title: " Present Simple II ",
        subtitle: "A1 - Present Progressive Tense",

        dateAdded: "Basic 0 ",
        channel: "sdasd",
        description: "Aprenderemos los concepto elemental en el idiomrir las habilidades necesarias para avanzar a niveles más altos de competencia en el futuro. ",
        enlaces: [
          

            {  titulo:"📖 Prepositions", url: "https://docs.google.com/presentation/d/1whWilz_x5_6fQ9uQ0_2jmEQulZmuSoMi_y_6X3HLmqY/edit?usp=sharing"},
            {  titulo:"📖 Professions",url: "https://docs.google.com/document/d/18WYvZntiIyTldbpPtcljy2bH27wKkud8/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true"},
            {  titulo:"[🖥️ Class] Present Simple con todos los verbos Afirmativo", url: "https://youtu.be/ZgqOqJMP6ec"},
            {  titulo:"[📊 Diagrama] Prensent Simple Affirmative", url: "https://drive.google.com/file/d/1fQLm5OLOa4PeRXDrsgl73M1EY9Yno7_F/view?usp=sharing"},

            {  titulo:"[🗂️Slide] Present Simple Tense Affirmative ",url: "https://docs.google.com/presentation/d/1hWVK_6KkwKxRtWJtx0TL-A4K5oPMdUQJ/edit?usp=sharing&ouid=101677822942011312590&rtpof=true&sd=true" },
            {  titulo:"[🧩 Activity] 3rd Person Rules",url: "https://wordwall.net/play/28761/823/4170" },
            {  titulo:"[🧩 Activity] Present Simple  Affirmative Form",url: "https://wordwall.net/play/57830/431/8032" },
            {  titulo:"[🔖Practice] Spelling Changes",url: "https://drive.google.com/file/d/1dpWuDqqkIR8au1C1PERB6pOz5H-ivktU/view?usp=sharing" },
            {  titulo:"[🔖Practice] Present Simple Affirmative Form I",url: "https://drive.google.com/file/d/1gn1jk2vGP960VU-D_9IU9QknhCfDbLQ_/view?usp=sharing" },
            {  titulo:"[🔖Practice] Present Simple Affirmative Form II",url: "https://drive.google.com/file/d/1RMuY04Q492JcJOO8goK8-JQp9kLktCYK/view?usp=sharing" },
            {  titulo:"[🖥️ Class] Present Simple con todos los verbos Negative", url: "https://youtu.be/AmHTz5A-8Cs"},
            {  titulo:"[📊 Diagrama] Prensent Simple Negative", url: "https://drive.google.com/file/d/1qn3gmgoev23lc4lFZlYHq5q-skIlsyYA/view?usp=sharing"},

            {  titulo:"[🔖Practice] Present Simple Negative Form I",url: "https://drive.google.com/file/d/1dvhm4IVAk_jXGiq86I0i6lBxZzLlA7v-/view?usp=sharing" },
            {  titulo:"[🔖Practice] Present Simple Negative Form II",url: "https://drive.google.com/file/d/1BCabvvBOmmIuh6lD5XRMWwch1l0oP-54/view?usp=sharing" },
            {  titulo:"[🔖Practice] Present Simple Yes/No Question ",url: "https://drive.google.com/file/d/1buU-xEfNvhliFhUqmIMQrKWAnPDCXlU7/view?usp=sharing" },
            {  titulo:"[🔖Practice] Present Simple Wh Question ",url: "https://drive.google.com/file/d/1fCLeWwtj35ziI_NLborQ2Mo1swL-m_rU/view?usp=sharing" },
            {  titulo:"[🔖Practice] Present Simple Mixed I  ",url: "https://drive.google.com/file/d/1wS1NV6i_XfNKTVSEDyIX-BJ3xkkgfmwX/view?usp=sharing" },
            {  titulo:"[🔖Practice] Present Simple Mixed II  ",url: "https://drive.google.com/file/d/1dbIdnY51wBQl5SxyYuqxVQF2GqioLRlt/view?usp=sharing" },
            {  titulo:"[🔖Practice] Present Simple Mixed III  ",url: "https://drive.google.com/file/d/1SXoJvjOeeYoEbPv1-9JrSCZvJWMiorgB/view?usp=sharing" },
            {  titulo:"[🔖Practice] Present Simple Mixed IV  ",url: "https://drive.google.com/file/d/1F6rawDVqTKM8NiTxMWDmNVxGIHKALDRx/view?usp=sharing" },
            { titulo: "💡🎦 Present Tense Simple 01  ",url: "https://drive.google.com/file/d/16-zgiVH0dbaoa7GqXz7gNfAQSXOOx7zl/view?usp=sharing", },
            { titulo: "💡🎦 Present Tense Simple 02  ",url: "https://drive.google.com/file/d/1UDHSqaN1269ZYDfTaet2_Cd8X2SlE-_f/view?usp=sharing", },
            { titulo: "💡🎦 Present Tense Simple 03  ",url: "https://drive.google.com/file/d/1zoXjEjhdZfGh35xQUsVQDFhBk5misIq0/view?usp=sharing", },

            {  titulo:"🚩 Listening Quiz", url: "https://forms.gle/6GitkPaDLfMyah3n7"},

            {  titulo:"📖 Possesive Adjectives", url: "https://docs.google.com/presentation/d/1zkn5eJjUJTDUUjOU45ZZIRu8-7c9saPO/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true" },
            {  titulo:"🧩Possesive Adjectives", url: "https://wordwall.net/play/55417/749/2837" },
            {  titulo:"🧩Possesive Adjectives I", url: "https://wordwall.net/play/18888/235/2402" },
            {  titulo:"📖 Possessive", url: "https://docs.google.com/presentation/d/1UijMuEx-DdbZETXjEUUtT6IPkWF0az2w/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true"},
            {  titulo:"🧩 Possessive Pronouns", url: "https://wordwall.net/play/52592/500/1753"},
            {  titulo:"📖 Object Pronouns ",url: "https://docs.google.com/presentation/d/1uF-fBeTnLSjeRJULZT-cxo1DHRiJBBidBqeyBhWxrh0/edit?usp=sharinghttps://docs.google.com/presentation/d/1uF-fBeTnLSjeRJULZT-cxo1DHRiJBBidBqeyBhWxrh0/edit?usp=sharing" },
            {  titulo:"🧩 Object Pronouns ", url: "https://wordwall.net/play/69980/389/917"},
            {  titulo:"🧩 Object Pronouns I", url: "https://wordwall.net/play/58591/627/3167"},
            {  titulo:"🚩 Reading Quiz", url: "https://forms.gle/dJmmufZ977WmRkN37"},
            {  titulo:"🚩 Reading Quiz ", url: "https://forms.gle/82QXSxvtB6BSPHLc8"},
            {  titulo:"☠️ Check Point 01",url: "https://drive.google.com/file/d/14hNicd6J5TxO0dILuMFwg85A8dmW7WTC/view?usp=sharing" },
            { titulo: "📖Explanation Adverbs of Frequency",url: "https://docs.google.com/presentation/d/12feKDZwOqILPrUSp6Nm6vtYqfcgjaQqR/edit?usp=sharing&ouid=114172849724389982127&rtpof=true&sd=true", },
            { titulo: "📖FREQUENCY ADVERBS AND ADVERBIAL PHRASES",url: "https://docs.google.com/presentation/d/16-wwNO2lpWVdp222T5v6qAx2Y84QG0RC/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true",},
            { titulo: "📖Explanation Adverbs of Frequency", url: "https://docs.google.com/presentation/d/12feKDZwOqILPrUSp6Nm6vtYqfcgjaQqR/edit?usp=sharing&ouid=114172849724389982127&rtpof=true&sd=true",},
            {  titulo:"🧩Adverbs of Frequency", url: "https://wordwall.net/play/54781/327/2832"},
            { titulo: "📖Imperatives",url: "https://docs.google.com/presentation/d/1IBGfgt3RbQSgNHUolh8T0JyXjv4NfvLS/edit?usp=sharing&ouid=114172849724389982127&rtpof=true&sd=true",},
            { titulo: "📖THE IMPERATIVE",url: "https://docs.google.com/presentation/d/1zecWMqAGGTYW3Ogmm7hSF44xZitwTedl/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true",},
            {  titulo:"🧩Imperatives",url: "https://wordwall.net/play/16378/903/4549" },

           
            {
                titulo: "📒[slides] Possessive Nouns",
                url: "https://docs.google.com/presentation/d/1bLZnrTpjyce03zBK452iwIl22MscWXAb/edit?usp=sharing&ouid=114172849724389982127&rtpof=true&sd=true",
            },
            {
                titulo: "📒[slides] Vocabulary Family",
                url: "https://docs.google.com/presentation/d/1vLAkUKANVHp8qr4HqaPaEeURLruLyKxx/edit?usp=sharing&ouid=114172849724389982127&rtpof=true&sd=true",
            },

            
            {
                titulo: "📒[slides] Too Vs Very ",
                url: "https://docs.google.com/presentation/d/1a6l6h79USa5zWCE39sn0VywhX0dKBJE1/edit?usp=share_link&ouid=114172849724389982127&rtpof=true&sd=true",
            },


            {
                titulo: "📒[slides] Questions with like -Personality Adjectives",
                url: "https://docs.google.com/presentation/d/1h-RZyzVXhOj7DIGmZ0EYFz9hmJB8obSa/edit?usp=sharing&ouid=114172849724389982127&rtpof=true&sd=true",
            },

            {  titulo:"25-📒[slides] Can vs Can't", url: "https://docs.google.com/presentation/d/1whWilz_x5_6fQ9uQ0_2jmEQulZmuSoMi_y_6X3HLmqY/edit?usp=sharing"},
           

            { titulo: "📝[skill test] UNIT 1: Listening and writing PDF",
                url: "https://drive.google.com/file/d/1lj6qtiswWIwvf0zSVne5b8dPEv3S3ra1/view?usp=sharing",
            },

           
          
            
            {
                titulo: "📒[slides] UNIT 4:CLAUSES WITH UNTIL, BEFORE, AFTER",
                url: "https://docs.google.com/presentation/d/1ThbilTcaiDU8Qyts6iz3Oxx8uOnC9_ki/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true",
            },
            
           
            
          
            
            {
                titulo: "📒[slides] UNIT 7:CAN/CAN’T—ABILITY",
                url: "https://docs.google.com/presentation/d/1MblKTYMvUxtStvDA4DF75g8Y0fc3tEbZ/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true",
            },
            {
                titulo: "📒[slides] UNIT 7:ADVERBS OF MANNER",
                url: "https://docs.google.com/presentation/d/1u8sgSerVcr47Mjm3dp9e6c0oa5oq55pL/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true",
            },
           
           
           
            {
                titulo: "📒[slides] UNIT 9:VERB PHRASES ",
                url: "https://docs.google.com/presentation/d/1FHariJeOWfNHEd7J6BfbI9b2guiorCcU/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true",
            },
          
          
            {
                titulo: "📒[slides] UNIT 11:DIRECT AND INDIRECT OBJECTS",
                url: "https://docs.google.com/presentation/d/1invT5oXLeCWs3ZoBJ63VqNDUsxtVwws3/edit?usp=sharing&ouid=115002005624760024053&rtpof=true&sd=true",
            },
           
           
            { titulo: "💡🎦 Present Progressive   01  ",url: "https://drive.google.com/file/d/1HetObvFCgAXNetY0dTPvLJzT2hreurco/view?usp=sharing", },

            
          
           
           
            
        ],
    },
  
  

     {
        id: 4,
        thumbnail: "https://i.ibb.co/rpNz4py/B2-FIRST-31.png",
        title: "Trucos de Pronunciación Básico ",
        subtitle: "Centro de Clasificación ",
    
        dateAdded: "Basic 0 ",
        channel: " ",
        description: "Si has llevado clases de inglés antes realiza un examen para calcular tu nivel,Envia tu examen para su corrección al correo temis_it@hotmail.com",
        enlaces: [
            {  titulo:"🎬Presentacion", url: "https://youtu.be/dWDfFM88dSA"},
          
            {  titulo:"🎬 Mi primer truco de Pronunciación",url: "https://drive.google.com/file/d/1VhB8Kjr3YbARZU6KhPMvlPa0pZi92hX0/view?usp=sharing",url2: "https://www.youtube.com/watch?v=gMlip7427kU&t=22s&ab_channel=MyEnglishBro"},           
            {  titulo:"🎬Diferencia de I/i", url: "https://www.youtube.com/watch?v=oMUO8eRSkXk"},

            {  titulo:"📑Diferencia de I/i", url: "https://drive.google.com/file/d/1M5_cODEz8FA51UDbOQ85Su9I5zKFOSCL/view?usp=sharing"},
            {  titulo:"📑Diferencia de /æ/, /ɑː/, y /ʌ/ ", url: "https://drive.google.com/file/d/1B1DI1uePifYoAs6EbQNYNvqz8dl4m9HU/view?usp=sharing"},
            {  titulo:"📑Th en Inglés de /θ/ y /ð/", url: "https://drive.google.com/file/d/1pPwuSgKPW9MNpN6TqFfjRZ__hw3W2wOK/view?usp=sharing"},

          
            {
                titulo: "💣PRONUNCIACIÓN en INGLÉS (Presentación)👄",
                url: "https://www.youtube.com/watch?v=-YocPrBjydE&list=PLaYNhMsVRuHgkd2T4axk-uFuJV-B9ZR2l&ab_channel=MyEnglishBro",
            },
            {
                titulo: "Trucos con la T",
                url: "https://www.youtube.com/watch?v=sh1-WReYeYY&list=PLaYNhMsVRuHgkd2T4axk-uFuJV-B9ZR2l&index=2&ab_channel=MyEnglishBro",
            },
            {
                titulo: "Dropped T",
                url: "https://www.youtube.com/watch?v=MBPAI8TI-HA&list=PLaYNhMsVRuHgkd2T4axk-uFuJV-B9ZR2l&index=3&ab_channel=MyEnglishBro",
            },
            {
                titulo: "T Flap",
                url: "https://www.youtube.com/watch?v=TAdE9TjixHk&list=PLaYNhMsVRuHgkd2T4axk-uFuJV-B9ZR2l&index=4&ab_channel=MyEnglishBro",
            },
            {
                titulo: " Omission ",
                url: "https://www.youtube.com/watch?v=EbfroOu4_EU&list=PLaYNhMsVRuHgkd2T4axk-uFuJV-B9ZR2l&index=5&ab_channel=MyEnglishBro",
            },
            {
                titulo: " T flap 2 ",
                url: "https://www.youtube.com/watch?v=8_-ABxzg3gE&list=PLaYNhMsVRuHgkd2T4axk-uFuJV-B9ZR2l&index=6&ab_channel=MyEnglishBro",
            },
            {
                titulo: " T flap 3",
                url: "https://www.youtube.com/watch?v=w2BDLl5TVvA&list=PLaYNhMsVRuHgkd2T4axk-uFuJV-B9ZR2l&index=7&ab_channel=MyEnglishBro",
            },
            {
                titulo: " T as Sh",
                url: "https://www.youtube.com/watch?v=VPFclhpx__s&list=PLaYNhMsVRuHgkd2T4axk-uFuJV-B9ZR2l&index=8&ab_channel=MyEnglishBro",
            },
            {
                titulo: " Consideraciones al Pronunciar",
                url: "https://www.youtube.com/watch?v=717NdjUV9Po&list=PLaYNhMsVRuHgkd2T4axk-uFuJV-B9ZR2l&index=9&ab_channel=MyEnglishBro",
            },
            {
                titulo: " T/D between 2 consonant sounds",
                url: "https://www.youtube.com/watch?v=vLUv888ckbk&list=PLaYNhMsVRuHgkd2T4axk-uFuJV-B9ZR2l&index=10&ab_channel=MyEnglishBro",
            },
          
          
        ],
    },
    
];
